import { useSelector } from "react-redux";
import documentApi from "../../api/documentApi";
import { RootState } from "../../store";

interface FileProps {
    type: string;
    title: string;
    size: string;
    fileKey: string;
    // onReload: () => void;
    onDelete: (id: number) => void;
    id: number;
}

function File(props: FileProps) {
    const { type, title, size, fileKey, id, onDelete } = props;
    const { user } = useSelector((state: RootState) => state.auth);
    const isStudent = user?.roles.includes("Học viên") || user?.roles.includes("student");

    const handleDownload = async () => {
        try {
            const res = await documentApi.downloadDocument(fileKey);

            const downloadUrl = res.data.downloadUrl;

            // ⭐ Mở file trong tab mới (PDF, hình ảnh...) hoặc trigger tải
            window.open(downloadUrl, "_blank");

        } catch (error) {
            console.error("Download failed", error);
        }
    };

    const handleDelete = async () => {
        onDelete(id);
    };

    const renderFileIcon = () => {
        const fileType = (type || "").toLowerCase();

        if (fileType.includes("pdf")) {
            return <i className="fa-solid fa-file-pdf text-[20px] text-red-500"></i>;
        }
        if (fileType.includes("doc") || fileType.includes("word")) {
            return <i className="fa-solid fa-file-word text-[20px] text-blue-500"></i>;
        }
        if (fileType.includes("xls") || fileType.includes("excel")) {
            return <i className="fa-solid fa-file-excel text-[20px] text-green-500"></i>;
        }
        if (fileType.includes("zip") || fileType.includes("rar")) {
            return <i className="fa-solid fa-file-zipper text-[20px] text-yellow-500"></i>;
        }
        if (fileType.includes("ppt") || fileType.includes("powerpoint")) {
            return <i className="fa-solid fa-file-powerpoint text-[20px] text-orange-500"></i>;
        }
        if (fileType.includes("png") || fileType.includes("jpg") || fileType.includes("jpeg") || fileType.includes("gif")) {
            return <i className="fa-solid fa-image text-[20px] text-orange-500"></i>;
        }
        // Mặc định: icon file chung
        return <i className="fa-solid fa-file text-[20px] text-gray-500"></i>;
    };

    return (
        <div className="flex items-center justify-between border-b border-[#f0f0f0] pb-[10px] last:border-b-0">
            <div className="rounded-[8px] w-[40px] h-[40px] bg-[rgba(52,152,219,0.1)] flex justify-center items-center">
                {renderFileIcon()}
            </div>
            <div className="flex flex-col items-start flex-1 ml-[10px] text-left lg:ml-[20px]">
                <div className="max-w-[200px] lg:flex-1 lg:max-w-full">
                    <h3 className="font-[700] text-[16px] truncate overflow-hidden whitespace-nowrap cursor-default">
                        {title}
                    </h3>
                </div>
                <p className="text-[14px] text-gray-500">{`${(type || "").toUpperCase()} - ${size}`}</p>
            </div>
            <div
                onClick={handleDownload}
                className="text-white py-[8px] px-[15px] rounded-[5px] w-fit h-[34px] bg-success flex justify-center items-center cursor-pointer hover:bg-green-600 transition"
            >
                <i className="fas fa-download text-[14px]"></i>
                <span className="text-[14px] ml-[10px]">Tải về</span>
            </div>
            {!isStudent && (<div
                onClick={handleDelete}
                className="ml-[20px] text-white py-[8px] px-[15px] rounded-[5px] w-fit h-[34px] bg-red-500 flex justify-center items-center cursor-pointer hover:bg-red-600 transition"
            >
                <i className="fas fa-trash text-[14px]"></i>
                <span className="text-[14px] ml-[10px]">Xóa file</span>
            </div>)}
        </div>
    );
}

export default File;
